import { render, staticRenderFns } from "./FAQElement.vue?vue&type=template&id=1e1704ed&"
import script from "./FAQElement.vue?vue&type=script&lang=js&"
export * from "./FAQElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports